export const RESET = 'RESET';
export const OPEN_TAB = 'OPEN_TAB';
export const RESET_TAB = 'RESET_TAB';
export const SET_VISIBLE = 'SET_VISIBLE';
export const SET_HEADER_VISIBLE = 'SET_HEADER_VISIBLE';

export enum ETab {
  DEFAULT,
  PRODUCTS,
}

export interface ISidebarState {
  activeTab?: ETab;
  visible: boolean;
  displayNavHeader: boolean;
}
